import * as React from 'react';

export default function useDisableGestures(target: React.RefObject<HTMLDivElement>) {
    React.useEffect(() => {
        if (!!target.current) {
            target.current!.addEventListener('gesturestart', disableGesture, {
                passive: false,
            });
            target.current!.addEventListener('gesturechange', disableGesture, {
                passive: false,
            });
            return () => {
                target.current!.removeEventListener('gesturestart', disableGesture);
                target.current!.removeEventListener('gesturechange', disableGesture);
            };
        } else {
            return undefined;
        }
    }, [target.current]);
}

function disableGesture(e: Event) {
    e.preventDefault();
    e.stopPropagation();
}
